export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            投稿联系
          </h2>
          <p className="text-foreground-600 text-base md:text-lg mb-8">
            如果你有优质漫画推荐、追更攻略或漫评投稿，欢迎通过以下方式联系我们。漫蛙漫画网持续招募热爱漫画的内容创作者，一起打造最好的漫画追更社区。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            <a href="#contact" className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className="ri-mail-line text-2xl text-primary-500"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-sm text-foreground-500">投稿漫评与推荐</p>
            </a>

            <a href="#contact" className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className="ri-discuss-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-sm text-foreground-500">品牌推广与合作</p>
            </a>

            <a href="#contact" className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-secondary-200 transition-colors">
                <i className="ri-question-answer-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-sm text-foreground-500">帮助改进追更体验</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}